import { restApiIP } from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApiIP.get("/api/classifications", { params });
};

const get = id => {
  return restApiIP.get(`/api/classifications/${id}`);
}

const upsert = data => {
  return restApiIP.post("/api/classifications", data);
};

const remove = ids => {
  return restApiIP.delete(`/api/classifications/${ids}`);
};

const classificationService = {
  getAll,
  get,
  upsert,
  remove
};

export default classificationService;